import { Component, ViewEncapsulation } from '@angular/core';
import { DDatosCompartidosCabecera } from '@dian-cmp/formulario';


@Component({
  selector: 'app-contenedor-formulario',
  templateUrl: './contenedor-formulario.component.html',
  styleUrls: ['./contenedor-formulario.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class ContenedorFormularioComponent {

  public dDatosCompartidosCabecera: DDatosCompartidosCabecera;
    
    constructor () {
    	this.dDatosCompartidosCabecera = new DDatosCompartidosCabecera();
    }
    actualizarValor(nuevoValor: string,nombreCampo: string) {
      this.dDatosCompartidosCabecera[nombreCampo] = nuevoValor; // Actualiza el valor en el padre
    }
}



// WEBPACK FOOTER //
// D:/github/490/rec_ng_recibopago490v7/src/app/components/formulario/contenedor-formulario/contenedor-formulario.component.ts